import React from "react";
import { BatteryCharging } from "lucide-react";

export default function Loader({ label = "Loading..." }) {
  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center bg-background gap-4" data-testid="app-loader">
      <div className="relative">
        <div className="h-14 w-14 rounded-xl bg-primary/10 flex items-center justify-center">
          <BatteryCharging className="h-7 w-7 text-primary animate-pulse" />
        </div>
      </div>
      <p className="text-sm text-muted-foreground font-medium">{label}</p>
    </div>
  );
}
